import { INSURANCE_TYPE } from '../constant/insurance';

export const applicantDetailsObjectConstructor = (applicantDetails, insuranceType) => {
	if (insuranceType === INSURANCE_TYPE.EMPLOYEE) return { employee: { ...applicantDetails } };
	return { assetLiability: { ...applicantDetails } };
};
